import * as firebase from 'firebase';

export function getDownloads(route) {
  return firebase
    .database()
    .ref(route)
    .once('value', (s) => {
      return s.val();
    });
}

// Atomic +1 on the server value, so it never depends on (or overwrites with) a stale local count.
export function incrementDownloads(route, child) {
  return firebase
    .database()
    .ref()
    .child(route)
    .child(child)
    .transaction((current) => (current || 0) + 1);
}



// WEBPACK FOOTER //
// ./src/components/firebaseQuerys.js